export enum GoodCardModuleEnum {
  POS = 'POS',
  TEF = 'TEF',
}
